<template>
  <v-card
    class="pa-2"
    style="cursor: pointer;"
    @click="editing = true"
  >
    <div class="d-flex justify-space-between mb-3">
      <div style="font-weight: bold">
        {{ map.title }}
      </div>
      <v-chip v-if="map.map_type" label outlined x-small style="color: grey;">
        {{ map.map_type }}
      </v-chip>
    </div>
    <DynamicMap :maxHeight="200" :maxWidth="200" :image_url="map.url"></DynamicMap>
    <div class="pa-3">
      <div>
        <v-chip
          v-for="league in map.leagues"
          :key="league + '-map-league'"
          x-small
          label outlined
          class="mr-2"
        >{{ leagueName(league) }}</v-chip>
      </div>
      <v-chip x-small :color="map.sport_id ? '' : 'red'" label outlined>{{ map.sport_id || 'No sport' }}</v-chip>
    </div>
    <!-- {{ map }} -->

    <v-dialog v-model="editing" max-width="800">
      <CreateMapBase :edit_map_base="map" />
    </v-dialog>
  </v-card>
</template>

<script>
import DynamicMap from '@/components/maps/DynamicMap.vue';
import CreateMapBase from '@/components/tiimi_admin/league/map/CreateMapBase.vue';
import { mapGetters } from 'vuex';

export default {
  components: { DynamicMap, CreateMapBase },
  props: {
    map: Object
  },
  data: () => ({
    editing: false
  }),
  computed: {
    ...mapGetters('admin', [
      'leagues'
    ])
  },
  methods: {
    leagueName(id) {
      const league = this.leagues.find(league => league.id === id)
      return league ? league.league_name : 'No league'
    }
  }
}
</script>